@if (actions.length > 0) {
<mat-action-list>
  <h3 matSubheader class="flex items-center">
    <mat-icon class="ml-1 mr-2">more_horiz</mat-icon>
    {{ 'frame.next' | transloco }}
  </h3>
  @for (action of actions; track action) { @if (action.visible()) {
  <button (click)="action.action()" [title]="action.label | transloco" mat-list-item>
    <div matListItemTitle>
      {{ action.label | transloco }}
    </div>
  </button>
  } }
</mat-action-list>
}
